import api from './axios'
import { initTheme } from '@/utils/theme'

const authService = {
  async login(credentials) {
    const response = await api.post('/login', {
      email: credentials.email,
      password: credentials.password,
      remember: credentials.remember
    })

    return response.data
  },

  async me() {
    const response = await api.get('/me')
    return response.data
  },

  async logout() {
    try {
      const response = await api.post('/logout')
      return response.data
    } finally {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('user')

      await initTheme()
    }
  }
}

export default authService
